import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {TipoTarefa} from "../gerais/models/tipo-tarefa";
import {TipoAcao} from "../gerais/models/tipo-acao";
import {TipoDocumento} from "../gerais/models/tipo-documento";
import {TipoDocumentoCliente} from "../gerais/models/tipo-documento-cliente";

@Injectable({
  providedIn: 'root'
})
export class CadastrosGeraisService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`CadastrosGeraisService`);
  }

  baseUrl = environment.apiUrl;

  selecionarListaTipoTarefas(): Observable<BaseResponse<TipoTarefa[]> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<TipoTarefa[]>>(`${this.baseUrl}/Gerais/TipoTarefa`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarListaTipoTarefas')));
  }

  selecionarListaTipoAcoes(): Observable<BaseResponse<TipoAcao[]> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<TipoAcao[]>>(`${this.baseUrl}/Gerais/TipoAcao`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarListaTipoAcoes')));
  }

  selecionarListaTipoDocumentos(): Observable<BaseResponse<TipoDocumento[]> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<TipoDocumento[]>>(`${this.baseUrl}/Gerais/TipoDocumento`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarListaTipoDocumentos')));
  }

  selecionarListaTipoDocumentosCliente(): Observable<BaseResponse<TipoDocumentoCliente[]> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<TipoDocumentoCliente[]>>(`${this.baseUrl}/Gerais/TipoDocumentoCliente`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarListaTipoDocumentosCliente')));
  }

  adicionarTipoTarefa(tipoTarefa: TipoTarefa): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Gerais/TipoTarefa`, tipoTarefa)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionarTipoTarefa')));
  }

  adicionarTipoAcao(tipoAcao: TipoAcao): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Gerais/TipoAcao`, tipoAcao)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionarTipoAcao')));
  }

  adicionarTipoDocumento(tipoDocumento: TipoDocumento): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Gerais/TipoDocumento`, tipoDocumento)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionarTipoDocumento')));
  }

  adicionarTipoDocumentoCliente(tipoDocumentoCliente: TipoDocumentoCliente): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Gerais/TipoDocumentoCliente`, tipoDocumentoCliente)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionarTipoDocumentoCliente')));
  }

  desativarTipoTipoTarefas(id: number): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .delete<BaseResponse<boolean>>(`${this.baseUrl}/Gerais/TipoTarefa/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`desativarTipoTipoTarefas`)));
  }

  desativarTipoTipoAcoes(id: number): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .delete<BaseResponse<boolean>>(`${this.baseUrl}/Gerais/TipoAcao/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`desativarTipoTipoAcoes`)));
  }

  desativarTipoDocumentos(id: number): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .delete<BaseResponse<boolean>>(`${this.baseUrl}/Gerais/TipoDocumento/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`desativarTipoDocumentos`)));
  }

  desativarTipoDocumentoCliente(id: number): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .delete<BaseResponse<boolean>>(`${this.baseUrl}/Gerais/TipoDocumentoCliente/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`desativarTipoDocumentoCliente`)));
  }
}
